import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getSubscriptionProvider from 'src/common/utils/subscription/getSubscriptionProvider';
import subscribedThroughWeb from 'src/common/utils/subscription/subscribedThroughWeb';
import { premiumSubscriptionStatus } from 'src/common/utils/subscription/subscriptionStatus';
import { selectSubscriptionProviderName, selectSubscriptionStatus } from '../../../selectors/me';
import ExternalSubscription from './External';
import RestorePurchase from './RestorePurchase';
import WebSubscription from './web/WebSubscription';

const statusesWithNoSubscription = [
  premiumSubscriptionStatus.unknown,
  premiumSubscriptionStatus.none,
];
const hasSubscription = (subscriptionStatus) =>
  !statusesWithNoSubscription.includes(subscriptionStatus);

export const SubscriptionSettings = ({
  hasWebSubscription,
  providerName,
  subscriptionStatus = '',
}) => {
  if (hasWebSubscription) {
    return <WebSubscription />;
  }

  if (hasSubscription(subscriptionStatus)) {
    return (
      <ExternalSubscription providerName={providerName} subscriptionStatus={subscriptionStatus} />
    );
  }

  return <RestorePurchase />;
};

SubscriptionSettings.propTypes = {
  hasWebSubscription: PropTypes.bool.isRequired,
  providerName: PropTypes.string.isRequired,
  subscriptionStatus: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const subProvider = selectSubscriptionProviderName(state);

  return {
    hasWebSubscription: subscribedThroughWeb(subProvider),
    providerName: getSubscriptionProvider(subProvider),
    subscriptionStatus: selectSubscriptionStatus(state),
  };
}

export default connect(mapStateToProps)(SubscriptionSettings);
